import React from 'react';
import { IllustratedButton, Center, Icon, Text } from '@wegroup/design-system';

interface Props {
  onClick: () => void;
  amountOfSelected?: number;
}

const MultiSelectOtherButton: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
  children,
  amountOfSelected = 0,
}) => {
  return (
    <IllustratedButton
      isChecked={amountOfSelected > 0}
      Illustration={
        <Center h="100%" alignSelf="center" flexGrow={1}>
          <Center
            w="14"
            h="14"
            bg={amountOfSelected > 0 ? 'primary.500' : 'gray.strokeAndBg'}
            borderRadius="full"
            transition="0.2s"
          >
            {amountOfSelected > 0 ? (
              <Text textStyle="h3Headline" color="white">
                {amountOfSelected}
              </Text>
            ) : (
              <Icon name="IconActionPlus" color="gray.300" />
            )}
          </Center>
        </Center>
      }
      onClick={onClick}
      {...{ checked: amountOfSelected > 0 }}
    >
      {children}
    </IllustratedButton>
  );
};

export default MultiSelectOtherButton;
